import { Component, input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';

import { PrismSnackbarService } from '@shure/prism-angular-components';
import { macAddressRegEx, serialNumberRegEx } from '@shure/shared/angular/ui/validators/common';

import { QrCodeClaimingService } from '../../../services/qr-code-claiming.service';
import { formatMacAddress } from '../../../utils/parse-claim-url';

/**
 * Route that handles claim URLs by storing the MAC/serial and redirecting. Currently handles
 * V1 and V2 of the claim URL, but can support any URLs that contain :serial and :mac params.
 */
@Component({
	selector: 'sh-claim-redirect-route',
	standalone: true,
	template: ''
})
export class ClaimRedirectRouteComponent implements OnInit {
	public readonly serial = input.required<string, string>({
		transform: (value) => value.toUpperCase()
	});
	public readonly mac = input.required<string, string>({
		transform: (value) => value.toUpperCase()
	});

	constructor(
		private readonly qrCodeClaimingService: QrCodeClaimingService,
		private readonly router: Router,
		private readonly snackbarService: PrismSnackbarService,
		private readonly transloco: TranslocoService
	) {}

	public ngOnInit(): void {
		const serialNumber = this.serial();
		const formattedMacAddress = formatMacAddress(this.mac());

		// If serial number or MAC address has invalid formatting, show error and redirect to /devices
		if (!serialNumberRegEx.test(serialNumber) || !macAddressRegEx.test(formattedMacAddress)) {
			this.snackbarService.open({
				message: this.transloco.translate('cloud.device-management.inventory.invalid-claim-mac-serial-message'),
				actionText: this.transloco.translate('common.buttons.close')
			});

			this.router.navigate(['devices'], { replaceUrl: true });
			return;
		}

		this.qrCodeClaimingService.saveScannedQrCode({
			serial: this.serial(),
			mac: formatMacAddress(this.mac())
		});

		this.qrCodeClaimingService.setGoToQrClaimingStepFlag();
		this.router.navigate(['devices', 'add'], { replaceUrl: true });
	}
}
